
export default function ValueProposition() {
  return (
    <section id="ueber-mich" className="py-28 bg-olive-50/50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <span className="text-gold-500 text-sm font-medium tracking-[0.2em] uppercase mb-4 block">
            Qualifikationen
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold mb-4 text-olive-900">
            Über mich
          </h2>
          <div className="w-16 h-px bg-gold-300 mx-auto mb-6"></div>
          <p className="text-lg text-olive-700 max-w-3xl mx-auto font-light">
            Fundierte Ausbildung & Klinische Erfahrung für deine optimale Behandlung
          </p>
        </div>

        {/* Ausbildung */}
        <div className="mb-20">
          <div className="grid md:grid-cols-2 gap-0 rounded-3xl overflow-hidden shadow-sm border border-olive-100 hover:shadow-xl transition-shadow duration-500">
            {/* Image – on mobile: first, on desktop: second (right) */}
            <div className="w-full h-[380px] md:h-auto overflow-hidden order-first md:order-last">
              <img
                src="https://storage.readdy-site.link/project_files/282f4fb1-17a3-40b7-81fd-9ffa411cf374/dcc677ef-2191-4dec-9e0a-335c32972784_Praxis-108-von-87.jpg?v=94b19450474db6300f026970e8968151"
                alt="Theresa Mühlbacher – Physiotherapeutin"
                className="w-full h-full object-cover object-center"
              />
            </div>
            {/* Text Box */}
            <div className="bg-white p-10 md:p-12 flex flex-col justify-center order-last md:order-first">
              <div className="w-16 h-16 bg-gradient-to-br from-gold-200 to-gold-300 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg mb-6">
                <i className="ri-graduation-cap-line text-3xl text-olive-900"></i>
              </div>
              <h3 className="font-serif text-2xl md:text-3xl font-semibold mb-5 text-olive-900">
                Fundierte Ausbildung & Klinische Erfahrung
              </h3>
              <p className="text-olive-700 leading-relaxed mb-8 font-light">
                Mein Weg zur Physiotherapeutin begann mit der Ausbildung an der Berufsfachschule für Physiotherapie in Rotthalmünster. Während dieser Zeit konnte ich in namhaften Kliniken der Region wertvolle Praxiserfahrung in den Bereichen Rehabilitation, Orthopädie und Akutmedizin sammeln:
              </p>
              <ul className="space-y-4">
                <li className="flex items-start gap-4 group">
                  <div className="w-10 h-10 bg-gold-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-gold-200 transition-colors">
                    <i className="ri-hospital-line text-gold-600 text-xl"></i>
                  </div>
                  <span className="text-olive-800 pt-2">Rehafachzentrum & Johannesbad Fachklinik, Bad Füssing</span>
                </li>
                <li className="flex items-start gap-4 group">
                  <div className="w-10 h-10 bg-gold-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-gold-200 transition-colors">
                    <i className="ri-hospital-line text-gold-600 text-xl"></i>
                  </div>
                  <span className="text-olive-800 pt-2">Passauer Wolf Reha, Bad Griesbach</span>
                </li>
                <li className="flex items-start gap-4 group">
                  <div className="w-10 h-10 bg-gold-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-gold-200 transition-colors">
                    <i className="ri-hospital-line text-gold-600 text-xl"></i>
                  </div>
                  <span className="text-olive-800 pt-2">Krankenhäuser Rotthalmünster & Vilshofen</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Spezialisierungen */}
        <div>
          <div className="text-center mb-12">
            <h3 className="font-serif text-3xl font-semibold text-olive-900">
              Spezialisierungen & Fortbildungen
            </h3>
            <div className="w-12 h-px bg-gold-300 mx-auto mt-4 mb-6"></div>
            <p className="text-olive-700 max-w-3xl mx-auto font-light">
              Um meine Patienten ganzheitlich behandeln zu können, habe ich mich in spezialisierten Fachbereichen intensiv weitergebildet
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Ganzheitliche Therapie */}
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-olive-100 hover:shadow-xl transition-all duration-500 group">
              <div className="w-16 h-16 bg-gradient-to-br from-gold-200 to-gold-300 rounded-2xl flex items-center justify-center mb-8 shadow-lg group-hover:scale-110 transition-transform duration-300">
                <i className="ri-heart-pulse-line text-3xl text-olive-900"></i>
              </div>
              <h4 className="font-serif text-xl font-semibold mb-6 text-olive-900">Ganzheitliche Therapie</h4>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-gold-500 text-lg flex-shrink-0 mt-0.5"></i>
                  <span className="text-olive-700 text-sm leading-relaxed">Cranio Sacrale Therapie nach Upledger (Basisausbildung CST I & CST II)</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-gold-500 text-lg flex-shrink-0 mt-0.5"></i>
                  <span className="text-olive-700 text-sm leading-relaxed">Viszerale Therapie: Fokus Verdauungstrakt – Wirbelsäule</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-gold-500 text-lg flex-shrink-0 mt-0.5"></i>
                  <span className="text-olive-700 text-sm leading-relaxed">Viszerale Therapie: Tinnitus, Schwindel, Kiefergelenksprobleme (CMD) und Begleitung bei Zahnspangen</span>
                </li>
              </ul>
            </div>

            {/* Ergänzende Verfahren */}
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-olive-100 hover:shadow-xl transition-all duration-500 group">
              <div className="w-16 h-16 bg-gradient-to-br from-gold-200 to-gold-300 rounded-2xl flex items-center justify-center mb-8 shadow-lg group-hover:scale-110 transition-transform duration-300">
                <i className="ri-hand-heart-line text-3xl text-olive-900"></i>
              </div>
              <h4 className="font-serif text-xl font-semibold mb-6 text-olive-900">Ergänzende Verfahren</h4>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-gold-500 text-lg flex-shrink-0 mt-0.5"></i>
                  <span className="text-olive-700 text-sm leading-relaxed">Narbenentstörung</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-gold-500 text-lg flex-shrink-0 mt-0.5"></i>
                  <span className="text-olive-700 text-sm leading-relaxed">Kinesiologisches Taping</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-gold-500 text-lg flex-shrink-0 mt-0.5"></i>
                  <span className="text-olive-700 text-sm leading-relaxed">Zertifizierter Nordic Walking Trainer</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
